import { render, staticRenderFns } from "./LeaderboardItem.vue?vue&type=template&id=0c96c1bc&scoped=true&"
import script from "./LeaderboardItem.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardItem.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardItem.vue?vue&type=style&index=0&id=0c96c1bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96c1bc",
  null
  
)

export default component.exports